import { Injectable } from "@angular/core";
import { ActivatedRoute, ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { Observable, ReplaySubject } from "rxjs";
import { FeatureFlagsService } from "src/app/services/infra/featureFlags/feature-flags.service";
import { environment } from "src/environments/environment";
import { UserLoaderGuard } from "../userLoader/user-loader.guard";

@Injectable({
    providedIn: "root",
})
export class FeatureFlagsGuard {
    constructor(
        private _featureFlagService: FeatureFlagsService,
        private _userLoaderGuard: UserLoaderGuard,
        private _router: Router,
        private _activeRoute: ActivatedRoute,
    ) {}

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const hasAccess$: ReplaySubject<boolean> = new ReplaySubject(1);

        this._userLoaderGuard.canActivate(route, state).subscribe({
            next: (isActivated) => {
                if (isActivated) {
                    const hasAccess = this._featureFlagService.canActivateRoute(route.url[0].path);

                    if (!hasAccess) {
                        window.location.href = `${environment.app_base_url}/app`;
                        hasAccess$.next(false);
                    } else {
                        hasAccess$.next(true);
                    }
                } else {
                    window.location.href = `${environment.app_base_url}/app`;
                    hasAccess$.next(false);
                }
            },
            error: (error) => {
                console.log(error);
                window.location.href = `${environment.app_base_url}/app`;
                hasAccess$.next(false);
            },
        });

        return hasAccess$;
    }
}
